var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "w-btn-icon",
    _vm._b(
      {
        staticClass: "w-btn-user",
        attrs: { hover: !!_vm.loggedIn, hoverAction: _vm.accountAction },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.accountAction.apply(null, arguments)
          },
        },
      },
      "w-btn-icon",
      { icon: _vm.icon, size: _vm.size },
      false
    ),
    [
      _c(
        "transition",
        { attrs: { name: "fade-fast", mode: "out-in" } },
        [
          _vm.loggedIn
            ? _c("i-account", { key: "user" })
            : _c("span", { key: "anon", staticClass: "sign-in" }, [
                _vm._v("sign in"),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }